/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ISegmentationProvider, ISementations } from '@msdyn365-commerce/core';
import Cookies from 'universal-cookie';
const UserConsentCookieName = '_msdyn365___ucc_';
const cookieOptionsWithDefaults = { path: '/', maxAge: 31536000, secure: true };

// set cookie to track sessions for new site
const cookies = new Cookies();
cookies.set(UserConsentCookieName, Date.now(), cookieOptionsWithDefaults);

/**
 * A basic implementation of the ExperimentationProvider interface used for testing
 */
class MsDyn365GeoLookupTestConnector implements ISegmentationProvider {
    private testSegments = {
        101: '25'
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public initialize(config: any): Promise<boolean> {
        console.log(`MsDyn365 Segmentation Test Connector called with config: ${JSON.stringify(config)}`);
        return Promise.resolve(true);
    }

    public async getSegmentations(userId: string, segmentationIds: string[]): Promise<ISementations> {
        console.log(`MsDyn365 Segmentation  Test Connector will resolve segments - ${segmentationIds} for ${userId}`);

        return Promise.resolve(this.testSegments);
    }
}

const connector = new MsDyn365GeoLookupTestConnector();
export default connector;
